module.exports = __webpack_public_path__ + "static/media/home_avatar5.27dd16fc.png";